import { ComponentProps } from 'react';
import dynamic from 'next/dynamic';

import { Button as SpButton } from './index.js';
import { ClearButton as SpClearButton } from './index.js';
import { CloseButton as SpCloseButton } from './index.js';

export const Button = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpButton,
        ComponentProps<typeof SpButton>
    >
>(() => import('./index.js').then(({ Button }) => Button), { ssr: false });
export const ClearButton = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpClearButton,
        ComponentProps<typeof SpClearButton>
    >
>(() => import('./index.js').then(({ ClearButton }) => ClearButton), {
    ssr: false,
});
export const CloseButton = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpCloseButton,
        ComponentProps<typeof SpCloseButton>
    >
>(() => import('./index.js').then(({ CloseButton }) => CloseButton), {
    ssr: false,
});
